import { getAuthModule } from 'auth/store/authModule';
import { getLayoutModule } from 'core-lib/reduxStore/layout/layoutModule';
import { getMiscModule } from 'core-lib/reduxStore/misc/miscModule';
import { getProfileModule } from 'core-lib/reduxStore/profile/profileModule';
import { getSettingModule } from 'core-lib/reduxStore/setting/settingModule';
import { getPaymentModule } from 'payments-ui-v2/store/paymentModule';
import { getCallDirectoryModule } from 'src/modules/CallDirectory/store/callDirectoryModule';
import { getMyCarDealerModule } from 'src/modules/CarDealer/store/myCarDealerModule';
import { getFastagModule } from 'src/modules/fastag/store/fastagModule';
import { getMallParkingModule } from 'src/modules/mallParking/store/mallParkingModule';
import { getDigitalPassModule } from 'src/modules/monthlyPass/store/digitalPassModule';
import { getUsedCarModule } from 'src/modules/usedCarDealer/store/usedCarModule';
import { getValetV2Module } from 'src/modules/valetV2/store/valetV2Module';
import { getTestDriveModule } from 'src/modules/testDrive/store/testDriveModule';
import { getVehicleModule } from 'chariot/store/vehicleModule';
import { getBBPSModule } from '../../modules/billPayment/store/BBPSModule';
import { getParkingModule } from '../../modules/parkingV2/store/parkingModule';
import { getWalletModule } from '../../modules/wallet/store/walletModule';
import { getSocietyReactivationModule } from '../../modules/societyReactivation/store/societyReactivation';
import { getDriverOnDemandModule } from 'src/modules/DriverOnDemand/store/driverOnDemand';
import { getChallanModule } from 'src/modules/challan/store/challanModule';
import { getRefinanceModule } from 'src/modules/refinance/store/refinanceModule';
import { getReferralModule } from 'src/modules/referAndEarn/store/referralModule';
import { getNewCarsModuleV2 } from 'src/modules/newCarsV2/store/NewCarsModule';
import { getCarInsuranceModule } from 'src/modules/carInsurance/store/CarInsuranceModule';
import { getCarServicingModule } from 'src/modules/carServicing/store/new/carServicingModule';
import { getReviewsModule } from 'src/modules/reviews/store/ReviewsModule';

export enum Modules {
  Auth,
  Misc,
  Layout,
  Profile,
  Setting,
  PaymentNew,
  Insurance,
  Wallet,
  FastagNew,
  VehicleNew,
  ParkPlusGo,
  ValetNew,
  ParkingV2,
  SocietyHome,
  Booking,
  userChallan,
  challan,
  usedCarDealer,
  DigitalPassModule,
  CarwashV2,
  MyCarDealer,
  mallParking,
  Discover,
  SocialCommunity,
  OffenceReport,
  BBPS,
  TestDrive,
  CallDirectory,
  NewCars,
  NewCarsV2,
  SocietyReactivation,
  DriverOnDemand,
  ValetV2,
  Refinance,
  Referral,
  CarInsurance,
  CarServicing,
  Reviews,
}

const reduxModuleMap = {
  [Modules.Layout]: getLayoutModule(),
  [Modules.Misc]: getMiscModule(),
  [Modules.Setting]: getSettingModule(),
  [Modules.Profile]: getProfileModule(),
  [Modules.Auth]: getAuthModule(),
  [Modules.PaymentNew]: getPaymentModule(),
  [Modules.ParkingV2]: getParkingModule(),
  [Modules.VehicleNew]: getVehicleModule(),
  [Modules.FastagNew]: getFastagModule(),
  [Modules.Wallet]: getWalletModule(),
  [Modules.challan]: getChallanModule(),
  [Modules.usedCarDealer]: getUsedCarModule(),
  [Modules.DigitalPassModule]: getDigitalPassModule(),
  [Modules.MyCarDealer]: getMyCarDealerModule(),
  [Modules.mallParking]: getMallParkingModule(),
  [Modules.BBPS]: getBBPSModule(),
  [Modules.TestDrive]: getTestDriveModule(),
  [Modules.CallDirectory]: getCallDirectoryModule(),
  [Modules.NewCarsV2]: getNewCarsModuleV2(),
  [Modules.SocietyReactivation]: getSocietyReactivationModule(),
  [Modules.DriverOnDemand]: getDriverOnDemandModule(),
  [Modules.ValetV2]: getValetV2Module(),
  [Modules.Refinance]: getRefinanceModule(),
  [Modules.Referral]: getReferralModule(),
  [Modules.CarInsurance]: getCarInsuranceModule(),
  [Modules.CarServicing]: getCarServicingModule(),
  [Modules.Reviews]: getReviewsModule(),
};

export const DEFAULT_REDUX_MODULES = [
  Modules.Auth,
  Modules.Layout,
  Modules.Misc,
  Modules.Setting,
  Modules.Profile,
];

export const loadReduxModules = (modules: any[]) => {
  const reduxModules = [];
  modules.forEach((m) => {
    reduxModules.push(reduxModuleMap[m]);
  });
  return reduxModules;
};
